(function($) {

  var $carouselItem = $('.c-carousel__item');
  var $dialogIntoCarousel = $carouselItem.find( $('.c-dialog') );

  // Moves the dialog that lives into the carousel before </body>,
  // otherwise the dialog opens into carousel item in a wrong way
  $dialogIntoCarousel.appendTo('body');

})(jQuery);